import { createSlice } from '@reduxjs/toolkit';
import { getAlertTags, getNewAlertsNotification, sendViewedAlertsUuids } from '../api';
import { REQUEST_STATUS } from '../constants';

let init_alert_list = {
  'Imminent Risk': {
    'count': 0,
    'type': 'critical',
  },
  'Help Seeking Behavior': {
    'count': 0,
    'type': 'nonCritical',
  },
  'Risk Factors Identified': {
    'count': 0,
    'type': 'nonCritical',
  },
};

export const alertsSlice = createSlice({
  name: 'alerts',
  initialState: {
    tablePreFilters: [],
    newAlertList: init_alert_list,
    alertTags: null,
    totalAlertsCount: 0,
    status: REQUEST_STATUS.idle,
    error: null,
    statusSendingViewedAlertsUuids: REQUEST_STATUS.idle,
  },
  reducers: {
    setAlertsPreFilter: (state, action) => {
      state.tablePreFilters = action.payload;
    },
    resetAlertsState: (state) => {
      state.newAlertList = init_alert_list;
      state.totalAlertsCount = 0;
      state.status = REQUEST_STATUS.idle;
      state.error = null;
      state.statusSendingViewedAlertsUuids = REQUEST_STATUS.idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getNewAlertsNotification.pending, (state) => {
        state.status = REQUEST_STATUS.loading;
      })
      .addCase(getNewAlertsNotification.rejected, (state, action) => {
        state.status = REQUEST_STATUS.failed;
        state.error = action.payload?.error || action.error?.message || 'Failed to load alerts';
      })
      .addCase(getNewAlertsNotification.fulfilled, (state, action) => {
        if (action.payload.ok) {
          state.status = REQUEST_STATUS.succeeded;
          let newState = {
            'Imminent Risk': {
              'count': 0,
              'totalCount': 0,
              'type': 'critical',
            },
            'Help Seeking Behavior': {
              'count': 0,
              'totalCount': 0,
              'type': 'nonCritical',
            },
            'Risk Factors Identified': {
              'count': 0,
              'totalCount': 0,
              'type': 'nonCritical',
            },
          };
          action.payload.data.data.items.forEach(({ title, count, totalCount }) => {
            if(title === 'IMMINENT RISK') {
              newState['Imminent Risk'].count = count;
              newState['Imminent Risk'].totalCount = totalCount ?? count;
            } else {
              newState[title].count = count;
              newState[title].totalCount = totalCount ?? count;
            }
          });
          state.totalAlertsCount = action.payload.data.data.totalCount ?? 0;
          state.newAlertList = newState;
        } else {
          state.status = REQUEST_STATUS.failed;
        }
      })
      .addCase(getAlertTags.fulfilled, (state, action) => {
        if (action.payload.ok) {
          state.alertTags = Object.fromEntries(
            Object.entries(action.payload.data.data).map(([key, value]) => [key, value.map(i => i.key)])
          );
        } else {
          // nothing
        }
      })
      .addCase(sendViewedAlertsUuids.pending, (state) => {
        state.statusSendingViewedAlertsUuids = REQUEST_STATUS.loading;
      })
      .addCase(sendViewedAlertsUuids.rejected, (state, action) => {
        state.statusSendingViewedAlertsUuids = REQUEST_STATUS.failed;
        state.error = action.payload?.error || action.error?.message || 'Failed to send viewed alerts';
      })
      .addCase(sendViewedAlertsUuids.fulfilled, (state, action) => {
        if (action.payload.ok) {
          state.statusSendingViewedAlertsUuids = REQUEST_STATUS.succeeded;
        } else {
          state.statusSendingViewedAlertsUuids = REQUEST_STATUS.failed;
        }
      })
  },
});

export const {
  setAlertsPreFilter,
  resetAlertsState,
} = alertsSlice.actions;

export default alertsSlice.reducer;
